import { IDetail } from './../api/proto/apiContract';
import { EventDisciplineMts } from '../enums/event';
import { ISBApiOperationResponse } from '../api/apiCommon';

export interface RootObject extends ISBApiOperationResponse<ReturnValueItem[]> {
}

export interface ReturnValueItem {
    DisciplineID: number;
    EventCount: number;
    Events: EventsItem[];
    GraphicsPresentationID: number | null;
    ID: number;
    Level: number;
    Name: string;
    NameShort: string | null;
    OfferType: number;
    Sequence: number;
}
export interface EventsItem {
    Actions: IEventAction[];
    ActiveCompetitor: number;
    CategoryPath: string;
    CatIds: number[];
    ClockStopped: boolean;
    ContinueAt: null;
    Date: string;
    DetailsCount: number;
    DisciplineID: EventDisciplineMts;
    ExternalID: string;
    GameGroups: IGameGroup[];
    GraphicsPresentationID: number;
    ID: number;
    Info: null;
    Name: string;
    RemainingPeriodTime: null | number;
    Results: ResultsItem[];
    State: number;
    StateName: string;
    StateTime: number | null;
    StreamTv: StreamTv;
    Type: number;
    ChangeTs: number;
    Competitors: CompetitorsItem[];
    StatisticsExternalId: null; // expected for Tipos only
    IsMatchTrackerAvailable: boolean | null; // expected for Tipos
    MatchTracker: MatchTracker | null; // for MTS
    Stats: Statistics | null; //for MTS
    Sequence: number; //mts, merge of categories
}

/**
 * Model for IGameGroup.
 * Copy of proto model, to add Initial into Game that is in Live.
 * Original intend was to have same model for prematch and live.
 * */
export interface IGameGroup {

    /** GameGroup ID */
    ID?: (number | null);

    /** GameGroup Name */
    Name?: (string | null);

    /** GameGroup Games */
    Games?: (IGame[] | null);

    /** GameGroup IsRapidBets */
    IsRapidBets?: (boolean | null);
}

/**
 * Model for IGame.
 * Copy of proto model, to add Initial into Game that is in Live.
 * Original intend was to have same model for prematch and live.
 * */
export interface IGame {

    /** Game ID */
    ID?: (string | null);

    /** Game Name */
    Name?: (string | null);

    /** Game Sequence */
    Sequence?: (number | null);

    Initial: boolean;

    /** Game Details */
    Details?: (IDetail[] | null);

    /** Game TemplateID */
    TemplateID?: (number | null);

    /** Game SequenceInSuperGame */
    SequenceInSuperGame?: (number | null);

    /** Game IsSuperGame */
    IsSuperGame?: (boolean | null);

    /** Game IsDetails */
    IsDetails?: (boolean | null);

    /** Game Info */
    Info?: (string | null);
}

interface IEventAction {
    Created: string;
    ID: string;
    ImageMapCode: string; //used for Tipos only
    Type: ActionType; //used for MTS!
    MatchTime: null;
    Name: string;
    SequenceId: number;
}
interface ResultsItem {
    Description: string;
    Flags: ResultFlag; //as flags of enum ResultFlag, use (Flags & ResultFlags.Game) == ResultFlags.Game!
    ID: number;
    IconID: number;
    ImportantResult: boolean;
    MainResult: boolean;
    Name: string;
    Score: string;
}
interface StreamTv {
    ID: string;
    Provider: number;
    StartDate: string;
}

export interface CompetitorsItem {
    ID: number;
    IsServer: boolean;
    Name: string;
}

export enum ResultFlag {  // used as flags, use (Flags & ResultFlags.Game) == ResultFlags.Game!
    None = 0,
    Game = 1,
    HalfTime = 2,
    CurrentPeriod = 4,
    BaseballBase = 8,
    SuspendedPlayer = 16,
    //BaseballInning = 32,
    IsPeriod = 64,
}

export enum ActionType {
    Unknown = 0,
    Goal = 1,
    YellowCard = 3,
    RedCard = 4,
    YellowRedCard = 5,
    MatchStart = 10,
    MatchEnd = 11,
    SuspendedPlayer = 12
}

export enum MatchTrackerType {
    BRMatch = 0,
    BRStage = 2
}

export interface MatchTracker {
    Type: MatchTrackerType; //default 0 comes as undefined
    Id: string;
}

export enum StatisticsType {
    BRMatch = 0,
    BRStage = 2
}

export interface Statistics {
    Type: StatisticsType; //default 0 comes as undefined
    Id: string;
}

export interface ApiLiveEventsStatusResponse extends ISBApiOperationResponse<ApiLiveEventsStatusData> {
}

export interface ApiLiveEventsStatusData {
    Items: ApiLiveEventsStatusItemData[] | null;
}

export interface ApiLiveEventsStatusItemData {
    /* event id */
    Id: number;

    MainScore: string,
    StateName: string;
    StateTime: (number | null);
    ImportantResults: ApiLiveEventsStatusResultItemData[];
}

export interface ApiLiveEventsStatusResultItemData {
    ID: number;
    Name: string;
    Score: string;
    Flags: number;
}